/**
 * Normalizes a Google Sheet URL (whether edit, view, or export format)
 * into a canonical edit URL suitable for opening in Google Sheets.
 */
export function normalizeGoogleSheetEditUrl(url?: string | null): string | undefined {
    if (!url) return undefined;
    const trimmed = url.trim();
    if (!trimmed) return undefined;

    if (trimmed.includes('docs.google.com/spreadsheets/d/')) {
        const match = trimmed.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
        if (match) {
            const docId = match[1];
            const gidMatch = trimmed.match(/[?&#]gid=([0-9]+)/);
            const gid = gidMatch ? gidMatch[1] : '0';
            return `https://docs.google.com/spreadsheets/d/${docId}/edit?gid=${gid}#gid=${gid}`;
        }
    }
    return trimmed;
}
